import { RawCustomFieldColorsResponse } from '../types'

export const selectCustomFieldColors = (
  responseDocument: RawCustomFieldColorsResponse
) => {
  return responseDocument.data.map((customFieldColor) => ({
    id: customFieldColor.id,
    type: customFieldColor.type,
    color: customFieldColor.attributes.color,
  }))
}
